import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withStyles } from 'material-ui/styles';
import { OAuthSignOutButton } from 'components';
import Divider from 'material-ui/Divider';
import Loader from '/components/Loader';
import List, { ListItem, ListItemText, ListSubheader } from 'material-ui/List';
import MenuItem from 'material-ui/Menu/MenuItem';
import Button from 'material-ui/Button';
import Paper from 'material-ui/Paper';
import SVG from 'react-inlinesvg';
import logo from 'logo.svg';
import TextField from 'material-ui/TextField';
import moment from 'moment';
import { pick } from 'lodash';
import { fetchOrganisation } from '/actions/xero';
import { submitXeroApplication, restoreCurrentApplication } from 'actions/applications';
import CustomCheckbox from '/components/FormComponents/Checkbox';
import TermsConditions from '/components/TermsConditions';

const styleSheet = (theme) => ({
  root: {
    backgroundColor: '#eee',
    flexGrow: 1,
    marginTop: theme.spacing.unit * 3,
    maxWidth: 900,
    margin: '0px auto'
  },
  paper: {
    padding: 16
  },
  signout: {
    float: 'right',
    marginRight: '15px',
    marginTop: '-20px',
  },
  textField: {
    marginTop: 0,
    marginLeft: theme.spacing.unit * 2,
    marginRight: theme.spacing.unit,
    width: 140,
  },
  checkBox: {
    marginTop: 0,
    marginLeft: theme.spacing.unit * 2,
    marginRight: theme.spacing.unit,
  },
  button: {
    float: 'right',
    height: 20,
  },
  error: {
    color: '#FF0050',
    marginTop: 0,
    marginLeft: theme.spacing.unit * 2,
    marginRight: theme.spacing.unit,
  }
});

class Xero extends Component {
  constructor(props) {
    super(props);
    this.state = {
      submitting: false,
      amount: 50000,
      termLength: 5,
      termUnit: 'month',
      drawdownDate: moment().add(3, 'days').format('YYYY-MM-DD'),
      frequency: 'month',
      termsAndConditions: false,
      errors: {}
    }
  };

  componentWillMount = () => {
    const { dispatch } = this.props;
    dispatch(fetchOrganisation());
    dispatch(restoreCurrentApplication());
  }

  validateForm = () => {
    if (!this.state.termsAndConditions) {
      this.setState({ errors: { termsAndConditions: "Must agree to terms and conditions to proceed." }});
      return false;
    }
    return true;
  }

  onSubmit = () => {
    if (!this.validateForm()) {
      return;
    }
    const { application, dispatch, organisation } = this.props;
    const form = pick(this.state, ['amount', 'termLength', 'termUnit', 'drawdownDate', 'frequency', 'termsAndConditions']);
    return dispatch(submitXeroApplication(form, organisation.id));
  }

  handleTermsAndConditions = (event) => {
    this.setState({ termsAndConditions: event.target.checked, errors: {} })
  }

  renderForm = () => {
    const { classes, organisation } = this.props;
    return (
      <div className={classes.root}>
        <OAuthSignOutButton className={classes.signout}/>
        <SVG src={logo} style={{ display: 'block', width: '100px', margin: '0 auto' }}/>
        <Paper style={{padding: 20, margin: 20}}>
          <List>
            <ListSubheader>Company details</ListSubheader>
            <ListItem>
              <b>Company Name:&nbsp;</b>
              {organisation.name}
            </ListItem>
            <ListItem>
              <b>ABN:&nbsp;</b>
              {organisation.abn}
            </ListItem>
            <ListItem>
              <b>Phone:&nbsp;</b>
              {organisation.phone}
            </ListItem>
            <ListItem>
              <b>Email:&nbsp;</b>
              {organisation.email}
            </ListItem>
            <ListSubheader>Loan application</ListSubheader>
            <TextField
              id="amount"
              label="Principal"
              className={classes.textField}
              value={this.state.amount}
              onChange={event => this.setState({ amount: event.target.value })}
              margin="normal"
            />
            <TextField
              id="termLength"
              label="Term duration"
              className={classes.textField}
              value={this.state.termLength}
              onChange={event => this.setState({ termLength: event.target.value })}
              margin="normal"
            />
            <TextField
              select
              id="termUnit"
              label="Day/week/month"
              className={classes.textField}
              value={this.state.termUnit}
              onChange={event => this.setState({ termUnit: event.target.value })}
              margin="normal"
            >
              <MenuItem key={'day'} value={'day'}>Day</MenuItem>
              <MenuItem key={'week'} value={'week'}>Week</MenuItem>
              <MenuItem key={'month'} value={'month'}>Month</MenuItem>
            </TextField>
            <TextField
              id="drawdownDate"
              label="Drawdown date"
              className={classes.textField}
              value={this.state.drawdownDate}
              onChange={event => this.setState({ drawdownDate: event.target.value })}
              margin="normal"
            />
            <TextField
              select
              id="frequency"
              label="Repayment"
              className={classes.textField}
              value={this.state.frequency}
              onChange={event => this.setState({ frequency: event.target.value })}
              margin="normal"
            >
              <MenuItem key={'week'} value={'week'}>Weekly</MenuItem>
              <MenuItem key={'month'} value={'month'}>Monthly</MenuItem>
            </TextField>
            <CustomCheckbox value="termsAndConditions" checked={this.state.termsAndConditions} onChange={this.handleTermsAndConditions} error={this.state.errors.termsAndConditions} />
            <ListItem>
              <Button
                raised
                color="primary"
                onClick={this.onSubmit}
                className={classes.button}
              >
                Submit
              </Button>
              <TermsConditions/>
            </ListItem>
          </List>
        </Paper>
      </div>
      );
  }

  renderLodged = () => {
    const { classes, application } = this.props;
    return (
      <div className={classes.root}>
        <OAuthSignOutButton className={classes.signout}/>
        <SVG src={logo} style={{ display: 'block', width: '100px', margin: '0 auto' }}/>
        <Paper style={{padding: 20, margin: 20}}>
          <div>
            <h4>Congratulations! Your application has been submitted for assessment. We'll contact you shortly.</h4>
            <div>Please write down your application number: <strong>{application.number}</strong> for further reference.</div>
          </div>
        </Paper>
      </div>
    );
  }

  render = () => {
    const { classes, organisation, application } = this.props;
    if (organisation) {
      if (application && application.status === "lodged") {
        return this.renderLodged();
      } else {
        return this.renderForm();
      }
    } else {
      return <Loader />;
    }
  }
}

const mapStateToProps = (state) => {
  const { organisation, application } = state;
  return { organisation, application };
};

const styled = withStyles(styleSheet)(Xero)
const connected = connect(mapStateToProps)(styled);

export default connected;



// WEBPACK FOOTER //
// ./src/containers/Xero/index.js